import type {
  ActivateDisciplineUseCase,
  ArchiveDisciplineUseCase,
  CreateDisciplineUseCase,
  GetDisciplineUseCase,
  ListDisciplinesUseCase,
  UpdateDisciplineUseCase,
} from '@/application/port/in/DisciplineUseCase';
import type {
  CreateDisciplineCommand,
  ListDisciplinesQuery,
  UpdateDisciplineCommand,
} from '@/application/port/in/dto/DisciplineCommand';
import type { DisciplineGateway } from '@/application/port/out/DisciplineGateway';
import type { Discipline } from '@/domain/model/Discipline';
import type { Page } from '@/domain/model/Page';

export class ListDisciplinesUseCaseImpl implements ListDisciplinesUseCase {
  constructor(private readonly gateway: DisciplineGateway) {}
  execute(query: ListDisciplinesQuery): Promise<Page<Discipline>> {
    return this.gateway.list(query);
  }
}

export class GetDisciplineUseCaseImpl implements GetDisciplineUseCase {
  constructor(private readonly gateway: DisciplineGateway) {}
  execute(id: string): Promise<Discipline> {
    if (!id) return Promise.reject(new Error('ID da disciplina é obrigatório'));
    return this.gateway.getById(id);
  }
}

export class CreateDisciplineUseCaseImpl implements CreateDisciplineUseCase {
  constructor(private readonly gateway: DisciplineGateway) {}
  execute(command: CreateDisciplineCommand): Promise<Discipline> {
    return this.gateway.create(command);
  }
}

export class UpdateDisciplineUseCaseImpl implements UpdateDisciplineUseCase {
  constructor(private readonly gateway: DisciplineGateway) {}
  execute(id: string, command: UpdateDisciplineCommand): Promise<Discipline> {
    return this.gateway.update(id, command);
  }
}

export class ActivateDisciplineUseCaseImpl implements ActivateDisciplineUseCase {
  constructor(private readonly gateway: DisciplineGateway) {}
  execute(id: string): Promise<Discipline> {
    if (!id) return Promise.reject(new Error('ID da disciplina é obrigatório'));
    return this.gateway.activate(id);
  }
}

export class ArchiveDisciplineUseCaseImpl implements ArchiveDisciplineUseCase {
  constructor(private readonly gateway: DisciplineGateway) {}
  execute(id: string): Promise<void> {
    if (!id) return Promise.reject(new Error('ID da disciplina é obrigatório'));
    return this.gateway.archive(id);
  }
}
